



import React from 'react'



import { List, ListIcon, ListItem, ListText } from "../../ppui/list";
import {
  ContentForm,
  ContentLayout,
  ContentMenu,
  ContentMenuSticky,
  ContentWrapper,
} from "../style";
import { MENU_ITEMS } from "./profile/profile-contants";
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../context/authContext';
import OrganizationStickyHeader from './organization-sticky-header';



const OrganizationLayout = () => {


  const {
    orgDetails,
  } = useAuthContext();

  const navigate = useNavigate();
  const location = useLocation();




  return (
    <ContentLayout>
      {/* <ContentHeading>
        <Typography variant="h5" mb="0">
          Organization
        </Typography>
      </ContentHeading> */}

      {orgDetails?.org_name &&
        <OrganizationStickyHeader orgDetails={orgDetails}
        />
      }
      <ContentWrapper>
        <ContentMenu>
          <ContentMenuSticky>
            <List
              size={"md"}
              color={"default"}
              activeColor={"default"}
              Colorvariant={"dark"}
              hover={"secondary"}
              gap={15}
            >
              {MENU_ITEMS.map((item, index) => (
                <ListItem
                  key={index}
                  onClick={() => {
                    if (item.shouldDisabledNewUser) {
                      if (orgDetails?.org_name) {
                        navigate(`/${item.path}`); // Add a leading slash for proper navigation
                      }
                    } else {
                      navigate(`/${item.path}`); // Add a leading slash for proper navigation
                    }
                  }}
                  isActive={
                    location.pathname === `/${item.path}` // Explicit match for current path
                  }
                  className={
                    location.pathname === `/${item.path}` ? "active" : ""
                  }
                  colorVariant="light"
                  disabled={item.shouldDisabledNewUser && !orgDetails?.org_name}
                >
                  <ListIcon>{item.icon}</ListIcon>
                  <ListText primary={item.primaryText} />
                </ListItem>
              ))}
            </List>


          </ContentMenuSticky>
        </ContentMenu>
        <ContentForm>
          <Outlet />
        </ContentForm>
      </ContentWrapper>
    </ContentLayout>
  )
}

export default OrganizationLayout